var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { useEffect, useState } from 'react';
import { useChart } from './useChart';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
export const useChecking = ({ virtualTransactions }) => {
    var _a;
    const { currentUserSession } = useUserSesssion();
    const { checkingAccount, pockets } = useStudentAccounts(false);
    const [data, setData] = useState([]);
    const { showCustomError } = useCustomToast();
    const [loading, setLoading] = useState(true);
    const { chartData, total } = useChart({ items: data });
    const getExpensesData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c;
        if (currentUserSession && ((_b = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _b === void 0 ? void 0 : _b.id) && (checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id)) {
            try {
                setLoading(true);
                const res = yield virtualTransactions.getExpenses({
                    idUser: (_c = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _c === void 0 ? void 0 : _c.id,
                    idAccountNumber: [checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id, ...pockets.map(pocket => pocket.id)]
                });
                setData(res);
                setLoading(false);
            }
            catch (error) {
                setLoading(false);
                showCustomError('Error', 'Error loading expenses');
            }
        }
    });
    // console.log(JSON.stringify(data));
    useEffect(() => {
        getExpensesData();
    }, [(_a = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.user) === null || _a === void 0 ? void 0 : _a.id, checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id]);
    return {
        chartData,
        total,
        loading
    };
};
